import React, { useContext, useEffect, useState } from "react"
import { useModal } from "../../../../hooks/ModalContext";
import { DiscadorContext } from "../../../Discador";
import { usePauseTime } from "../../../../hooks/usePauseTime";



export const PausasHibrido = () => {
  const { onClose, infoPausa, setModal } = useModal();
  const { iniciarPausa, finalizarPausa, dadosLogin, onPause, isLogged } = useContext(DiscadorContext)
  const { contagem, setContagem } = usePauseTime()

  const [time, setTime] = useState(0)
  const [hours, setHours] = useState(~~(time / 3600));
  const [minutes, setMinutes] = useState(~~((time % 3600) / 60));
  const [seconds, setSeconds] = useState(~~time % 60);

  function getContagemMinutes(minutes: number) {
    const h = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const s = Math.floor((minutes % 1) * 60);
    const tempo = `${String(h).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    setTime(h * 3600 + remainingMinutes * 60 + s);
    setContagem(tempo);
  }

  useEffect(() => {
    getContagemMinutes(infoPausa?.minutes)
  }, [infoPausa])

  useEffect(() => {
    let interval: NodeJS.Timeout = setInterval(() => { }, 0);
    const iniciarContagem = () => {
      interval = setInterval(() => {
        setTime(time - 1);
      }, 1000);
    };
    if (onPause) {
      iniciarContagem();
    } else {
      clearInterval(interval);
      getContagemMinutes(infoPausa?.minutes)
    }
    return () => clearInterval(interval);
  }, [onPause, time])

  useEffect(() => {
    setHours(~~(time / 3600));
    setMinutes(~~((time % 3600) / 60));
    setSeconds(~~time % 60);

    let hora = `${hours < 10 ? '0' : ''}${hours}`;
    let minuto = `${minutes < 10 ? '0' : ''}${minutes}`;
    let segundo = `${seconds < 10 ? '0' : ''}${seconds}`;

    setContagem(`${hora}:${minuto}:${segundo}`);
  }, [time, hours, minutes, seconds]);

  function pause() {
    iniciarPausa(dadosLogin!.idUsuario, String(infoPausa?.id), infoPausa.name)
    return
    // setModal('O operador precisa estar logado para usar essa função', 'Error', false, true)
  }

  function offPause() {
    if (isLogged && onPause) {
      finalizarPausa(dadosLogin!.idUsuario)
      onClose()
      return
    }
    // setModal('O operador precisa estar no intervalo para poder usar essa função', 'Error', false, true)
  }
  return (
    <>
      <div className="flex flex-col px-4 pb-4 text-gray-800">
        <div className="flex w-full items-center justify-center gap-2 -mt-4">
          <h4 className="my-4 text-base font-semibold text-primary">Tempo restante</h4>
        </div>

        <div className="flex items-center justify-center flex-col gap-4 my-4">
          <p className="text-sm">{infoPausa.name}</p>
          <strong className="text-3xl">{contagem}</strong>
        </div>

        {
          !onPause ? (
            <button className="-mb-4 mt-4 rounded-md bg-primary p-2 font-semibold text-white"
              onClick={() => pause()}
            >Iniciar intervalo</button>
          ) : (
            <button className={`-mb-4 mt-4 rounded-md bg-error p-2 font-semibold ${!onPause && "opacity-70 pointer-events-none"}  text-white`} onClick={() => offPause()}>Sair do intervalo</button>
          )
        }
      </div>
    </>
  )
}